import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    AisRestService,
    BaseQuestionIdentifier,
    ConditionDisclosureResource,
    EmbeddableResourceNames,
    QuestionAnswerType,
    QuestionType,
    ScreensQuestionResource
} from '@Components/mras/core';

@Component({
    selector: 'jhi-question-conditional',
    templateUrl: './question-conditional.component.html',
    styles: []
})
export class QuestionConditionalComponent implements OnInit {
    readonly QuestionAnswerType = QuestionAnswerType;
    readonly QuestionType = QuestionType;

    @Input()
        summaryMode: boolean;

    @Input()
        question: ScreensQuestionResource;
    @Output()
        questionChange = new EventEmitter<ScreensQuestionResource>();

    @Input()
        disclosures: ConditionDisclosureResource[];
    @Output()
        disclosuresChange = new EventEmitter<ConditionDisclosureResource[]>();
    @Input()
        questionIdentifier: BaseQuestionIdentifier;

    @Output()
        onQuestionChange = new EventEmitter<ScreensQuestionResource>();

    answerValue: any;
    httpErrorMsg: string;

    constructor(private aisRestService: AisRestService) {}

    ngOnInit(): void {
        this.answerValue = this.question.answerValue;
        if (this.question.picklistQuestionMeta != null) {
            this.answerValue = this.question.disclosures.map(e => e.aliasName).join(',');
        }
    }

    answer() {
        const resource = new ScreensQuestionResource();
        resource.answerValue = this.answerValue;
        this.httpErrorMsg = null;

        const linkedAlias = this.question.linkedAlias;

        this.aisRestService.answerBaseQuestion(this.questionIdentifier, resource).subscribe(
            e => {
                if (e.errorCode && e.errorCode !== '') {
                    this.httpErrorMsg = e.errorCode;
                    return;
                }

                Object.keys(this.question).forEach(f => delete this.question[f]);
                Object.assign(this.question, e);
                this.questionChange.emit(this.question);
                (e._embedded[EmbeddableResourceNames.AFFECTED_QUESTIONS] || []).forEach(f => {
                    this.onQuestionChange.emit(f);
                });
                const embeddedDisclosures = ((this.question._embedded || [])[EmbeddableResourceNames.DISCLOSURES] ||
                    []) as ConditionDisclosureResource[];


                if (!embeddedDisclosures || embeddedDisclosures.length <= 0) {
                    // look for any disclosures we already have and remove them

                    const oldDisclosures =  this.disclosures.filter(f => f.aliasName === linkedAlias);
                    oldDisclosures.forEach(oldDisclosure => Object.keys(oldDisclosure).forEach(f => delete oldDisclosure[f]));
                }

                embeddedDisclosures.forEach(newDisclosure => {
                    const oldDisclosure = this.disclosures.find(f => f.aliasName === newDisclosure.aliasName);
                    if (oldDisclosure == null) {
                        this.disclosures.push(newDisclosure);
                        return;
                    }
                    Object.keys(oldDisclosure).forEach(f => delete oldDisclosure[f]);
                    Object.assign(oldDisclosure, newDisclosure);
                });
                this.disclosuresChange.emit(this.disclosures);
            },
            errMsg => (this.httpErrorMsg = errMsg)
        );
    }
}
